<template>
    <el-dialog
        :visible="visible"
        :title="isEdit ? 'Chỉnh sửa hồ sơ ứng viên' : 'Thêm mới hồ sơ ứng viên'"
        width="700px"
        custom-class="rcv-dialog rcv-form-dialog"
        :close-on-click-modal="false"
        append-to-body
        @update:visible="close"
        @closed="onClosed"
    >
        <div slot="title" class="rcv-dialog-header">
            <div class="rcv-dialog-header__icon" :class="{ 'is-edit': isEdit }">
                <i :class="isEdit ? 'el-icon-edit-outline' : 'el-icon-user-solid'"></i>
            </div>
            <div class="rcv-dialog-header__info">
                <h3 class="rcv-dialog-header__title">
                    {{ isEdit ? 'Chỉnh sửa hồ sơ ứng viên' : 'Thêm mới hồ sơ ứng viên' }}
                </h3>
                <p class="rcv-dialog-header__subtitle">
                    {{ isEdit ? `Cập nhật thông tin ứng viên #${candidateData ? candidateData.id : ''}` : 'Nhập thông tin cá nhân và đính kèm CV cho vị trí tuyển dụng' }}
                </p>
            </div>
        </div>

        <el-form
            ref="formRef"
            :model="form"
            :rules="rules"
            label-position="top"
            size="small"
            class="rcv-form"
        >
            <!-- 1. Vị trí / Yêu cầu tuyển dụng -->
            <div class="rcv-form-section">
                <div class="rcv-form-section__head">
                    <i class="el-icon-suitcase-1"></i>
                    <span>Vị trí tuyển dụng</span>
                </div>

                <el-form-item label="Yêu cầu tuyển dụng" prop="job_id" required class="mb-0">
                    <el-select
                        v-model="form.job_id"
                        :disabled="isEdit || !!defaultJobId"
                        placeholder="Chọn yêu cầu tuyển dụng..."
                        filterable
                        clearable
                        class="w-100"
                        @change="handleOrderChange"
                    >
                        <el-option
                            v-for="order in orders"
                            :key="order.id"
                            :label="`#${order.id}${order.recruitment_job_id ? ` (Job #${order.recruitment_job_id})` : ''} - ${order.title || order.position_title || 'Yêu cầu tuyển dụng'}`"
                            :value="order.id"
                        >
                            <span class="rcv-order-opt__title">
                                #{{ order.id }}<span v-if="order.recruitment_job_id" style="color: #6366f1; font-weight: 600;"> (Job #{{ order.recruitment_job_id }})</span> - {{ order.title || order.position_title }}
                            </span>
                            <span v-if="order.department && order.department.name" class="rcv-order-opt__dept">
                                {{ order.department.name }}
                            </span>
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>

            <!-- 2. Thông tin cá nhân ứng viên -->
            <div class="rcv-form-section">
                <div class="rcv-form-section__head">
                    <i class="el-icon-user"></i>
                    <span>Thông tin ứng viên</span>
                </div>

                <el-form-item label="Họ và tên ứng viên" prop="name" required>
                    <el-input
                        v-model="form.name"
                        placeholder="Nhập đầy đủ họ và tên (VD: Nguyễn Văn A)"
                        clearable
                        prefix-icon="el-icon-user"
                    />
                </el-form-item>

                <el-row :gutter="14">
                    <el-col :span="12">
                        <el-form-item label="Số điện thoại" prop="phone" required>
                            <el-input
                                v-model="form.phone"
                                placeholder="VD: 0987654321"
                                clearable
                                prefix-icon="el-icon-phone-outline"
                            />
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="Email" prop="email" required>
                            <el-input
                                v-model="form.email"
                                placeholder="VD: ungvien@gmail.com"
                                clearable
                                prefix-icon="el-icon-message"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="Địa chỉ" prop="address" class="mb-0">
                    <el-input
                        v-model="form.address"
                        placeholder="Nhập địa chỉ cư trú của ứng viên"
                        clearable
                        prefix-icon="el-icon-location-outline"
                    />
                </el-form-item>
            </div>

            <!-- 3. File đính kèm & Nguồn CV -->
            <div class="rcv-form-section">
                <div class="rcv-form-section__head">
                    <i class="el-icon-paperclip"></i>
                    <span>Tệp đính kèm & Nguồn CV</span>
                </div>

                <el-form-item label="Nguồn CV" prop="source_type" required>
                    <el-radio-group v-model="form.source_type" class="rcv-source-radios">
                        <el-radio :label="1" border size="small">
                            <i class="el-icon-user"></i> 1 - Ứng viên tự apply
                        </el-radio>
                        <el-radio :label="2" border size="small">
                            <i class="el-icon-connection"></i> 2 - Lấy trên mạng
                        </el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="File CV ứng viên" prop="cv_file" class="mb-0">
                    <div class="rcv-upload-zone">
                        <!-- Nút upload & Trigger -->
                        <el-upload
                            ref="uploadRef"
                            action=""
                            multiple
                            :auto-upload="false"
                            :show-file-list="false"
                            accept=".pdf,.doc,.docx"
                            :on-change="handleFileChange"
                            class="rcv-upload-trigger"
                        >
                            <div class="rcv-upload-btn-wrap">
                                <el-button size="small" icon="el-icon-upload2" type="primary" plain class="rcv-upload-btn">
                                    {{ uploadRawFiles.length > 0 ? "Chọn thêm file CV" : "Chọn file CV tải lên" }}
                                </el-button>
                                <span class="rcv-upload-hint">Chấp nhận file định dạng PDF, DOC, DOCX (có thể chọn nhiều file)</span>
                            </div>
                        </el-upload>

                        <!-- Header thông tin file đã chọn -->
                        <div v-if="uploadRawFiles.length > 0" class="rcv-files-header">
                            <span class="rcv-files-count">
                                <i class="el-icon-files"></i> Đã chọn {{ uploadRawFiles.length }} file CV:
                            </span>
                            <el-button v-if="uploadRawFiles.length > 1" type="text" size="mini" class="rcv-btn-clear-all" @click="clearAllFiles">
                                Xoá tất cả
                            </el-button>
                        </div>

                        <!-- Danh sách file vừa chọn từ máy -->
                        <div v-if="uploadRawFiles.length > 0" class="rcv-files-list">
                            <div
                                v-for="(fItem, idx) in uploadRawFiles"
                                :key="fItem.uid || idx"
                                class="rcv-file-card"
                            >
                                <div class="rcv-file-card__icon">
                                    <i class="el-icon-document"></i>
                                </div>
                                <div class="rcv-file-card__info">
                                    <div class="rcv-file-card__name" :title="fItem.name">{{ fItem.name }}</div>
                                    <div class="rcv-file-card__status">
                                        <span v-if="fItem.sizeFormatted" class="rcv-file-card__size">{{ fItem.sizeFormatted }} · </span>
                                        <span class="text-success"><i class="el-icon-check"></i> Sẵn sàng tải lên</span>
                                    </div>
                                </div>
                                <el-tooltip content="Xoá file này" placement="top">
                                    <button type="button" class="rcv-file-card__remove" @click="removeFile(idx)">
                                        <i class="el-icon-close"></i>
                                    </button>
                                </el-tooltip>
                            </div>
                        </div>

                        <!-- Link file hiện có (khi edit) nếu chưa chọn file mới -->
                        <div v-if="form.cv_file && uploadRawFiles.length === 0" class="rcv-file-card rcv-file-card--existing">
                            <div class="rcv-file-card__icon">
                                <i class="el-icon-link"></i>
                            </div>
                            <div class="rcv-file-card__info">
                                <div class="rcv-file-card__name">File CV hiện tại</div>
                                <a :href="form.cv_file" target="_blank" class="rcv-file-card__link">
                                    Xem tệp đính kèm <i class="el-icon-top-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </el-form-item>
            </div>

            <!-- 4. Lời nhắn / Thư ứng tuyển -->
            <div class="rcv-form-section">
                <div class="rcv-form-section__head">
                    <i class="el-icon-chat-dot-round"></i>
                    <span>Lời nhắn / Thư ứng tuyển</span>
                </div>

                <el-form-item prop="message" class="mb-0">
                    <el-input
                        v-model="form.message"
                        type="textarea"
                        :rows="3"
                        placeholder="Nhập lời nhắn ứng tuyển, tóm tắt kinh nghiệm hoặc ghi chú quan trọng về ứng viên..."
                        maxlength="2000"
                        show-word-limit
                    />
                </el-form-item>
            </div>
        </el-form>

        <div slot="footer" class="rcv-dialog-footer">
            <el-button size="small" class="rcv-btn-cancel" @click="close">
                Huỷ
            </el-button>
            <el-button
                size="small"
                type="primary"
                :loading="submitting"
                icon="el-icon-check"
                class="rcv-btn-submit"
                @click="submit"
            >
                {{ isEdit ? "Lưu thay đổi" : "Tạo hồ sơ ứng viên" }}
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { RO_GET_TEACHER_GROUPS } from "@/core/services/store/recruitment-orders/recruitmentOrders.module";

function blankForm() {
    return {
        id: null,
        name: "",
        phone: "",
        email: "",
        address: "",
        job_id: null,
        source_type: 1, // 1: Ứng viên tự apply, 2: Lấy trên mạng
        preliminary_info: "",
        type: 0,
        status: 0,
        person_in_charge_id: null,
        teamlead_id: null,
        cv_file: "",
        message: "",
        official_salary: null,
        salary: null,
        probation_date: "",
        probation_reason: "",
        probation_result: null,
        probation_note: null,
    };
}

export default {
    name: "CvFormDialog",
    props: {
        visible: { type: Boolean, default: false },
        candidateData: { type: Object, default: null },
        orders: { type: Array, default: () => [] },
        defaultJobId: { type: [Number, String], default: null },
        submitting: { type: Boolean, default: false },
    },
    data() {
        return {
            form: blankForm(),
            uploadRawFiles: [],
            uploadRawFile: null,
            selectedFileName: "",
            hrUsers: [],
            teamLeads: [],
            rules: {
                name: [
                    { required: true, message: "Vui lòng nhập họ tên ứng viên", trigger: "blur" },
                    { max: 255, message: "Họ tên tối đa 255 ký tự", trigger: "blur" },
                ],
                phone: [
                    { required: true, message: "Vui lòng nhập số điện thoại", trigger: "blur" },
                ],
                email: [
                    { required: true, message: "Vui lòng nhập email", trigger: "blur" },
                    { type: "email", message: "Email không đúng định dạng", trigger: "blur" },
                ],
                job_id: [
                    { required: true, message: "Vui lòng chọn vị trí / yêu cầu tuyển dụng", trigger: "change" },
                ],
                source_type: [
                    { required: true, message: "Vui lòng chọn nguồn CV", trigger: "change" },
                ],
            },
        };
    },
    computed: {
        isEdit() {
            return !!(this.candidateData && this.candidateData.id);
        },
        selectedOrder() {
            if (!this.form.job_id) return null;
            return this.findOrder(this.form.job_id);
        },
        isTeacherOrder() {
            const o = this.selectedOrder;
            if (!o) return false;
            return (
                Number(o.type) === 2 ||
                Number(o.type) === 1 ||
                !!o.teacher_group_id ||
                Number(o.department_id) === 52
            );
        },
        hrOptions() {
            const list = [...this.hrUsers];
            if (this.form.person_in_charge_id) {
                const found = list.some((u) => String(u.id) === String(this.form.person_in_charge_id));
                if (!found && this.candidateData && this.candidateData.person_in_charge) {
                    list.unshift(this.candidateData.person_in_charge);
                }
            }
            return list;
        },
        teamLeadOptions() {
            const list = [...this.teamLeads];
            if (this.form.teamlead_id) {
                const found = list.some((u) => String(u.id) === String(this.form.teamlead_id));
                if (!found && this.candidateData && this.candidateData.teamlead) {
                    list.unshift(this.candidateData.teamlead);
                }
            }
            return list;
        },
    },
    watch: {
        visible(val) {
            if (val) {
                this.loadUserData();
                this.syncFormData();
            }
        },
        candidateData: {
            deep: true,
            handler() {
                if (this.visible) {
                    this.syncFormData();
                }
            },
        },
        defaultJobId(val) {
            if (!this.isEdit && val) {
                const found = this.findOrder(val);
                this.form.job_id = found ? found.id : (isNaN(Number(val)) ? val : Number(val));
                if (found) {
                    this.handleOrderChange(found.id);
                }
            }
        },
        orders: {
            handler() {
                if (this.visible && !this.isEdit && this.defaultJobId) {
                    const found = this.findOrder(this.defaultJobId);
                    if (found && (!this.form.job_id || String(this.form.job_id) !== String(found.id))) {
                        this.form.job_id = found.id;
                        this.handleOrderChange(found.id);
                    }
                }
            },
        },
    },
    methods: {
        findOrder(jobIdOrOrderId) {
            if (!jobIdOrOrderId) return null;
            const str = String(jobIdOrOrderId);
            return (this.orders || []).find((o) =>
                String(o.id) === str ||
                (o.recruitment_job_id !== undefined && o.recruitment_job_id !== null && String(o.recruitment_job_id) === str) ||
                (o.job_id !== undefined && o.job_id !== null && String(o.job_id) === str)
            ) || null;
        },
        syncFormData() {
            if (this.candidateData && this.candidateData.id) {
                const val = this.candidateData;
                this.form = {
                    id: val.id,
                    name: val.name || "",
                    phone: val.phone || "",
                    email: val.email || "",
                    address: val.address || "",
                    job_id: val.job_id ? Number(val.job_id) : (this.defaultJobId ? Number(this.defaultJobId) : null),
                    source_type: val.source_type !== undefined && val.source_type !== null ? Number(val.source_type) : 1,
                    preliminary_info: val.preliminary_info || val.preliminary_note || "",
                    type: val.type !== undefined ? Number(val.type) : 0,
                    status: val.status !== undefined && val.status !== null ? Number(val.status) : 0,
                    person_in_charge_id: val.person_in_charge_id || (val.person_in_charge && val.person_in_charge.id) || null,
                    teamlead_id: val.teamlead_id || (val.teamlead && val.teamlead.id) || null,
                    cv_file: val.cv_file || "",
                    message: val.message || "",
                    official_salary: val.official_salary !== undefined && val.official_salary !== null ? val.official_salary : null,
                    salary: val.salary !== undefined && val.salary !== null ? val.salary : null,
                    probation_date: val.probation_date || "",
                    probation_reason: val.probation_reason || "",
                    probation_result: val.probation_result || null,
                    probation_note: val.probation_note || null,
                };
                this.uploadRawFiles = [];
                this.uploadRawFile = null;
                this.selectedFileName = "";
            } else {
                const found = this.defaultJobId ? this.findOrder(this.defaultJobId) : null;
                const defaultJob = found
                    ? found.id
                    : (this.defaultJobId ? (isNaN(Number(this.defaultJobId)) ? this.defaultJobId : Number(this.defaultJobId)) : null);
                this.form = blankForm();
                this.form.job_id = defaultJob;

                // Tự động gán người phụ trách theo order nếu order đã có
                if (defaultJob) {
                    this.handleOrderChange(defaultJob);
                }
                this.uploadRawFiles = [];
                this.uploadRawFile = null;
                this.selectedFileName = "";
            }
        },
        handleOrderChange(orderId) {
            if (!orderId) {
                this.form.person_in_charge_id = null;
                this.form.teamlead_id = null;
                return;
            }
            const foundOrder = this.findOrder(orderId);
            if (foundOrder) {
                this.form.person_in_charge_id = foundOrder.person_in_charge_id || (foundOrder.person_in_charge && foundOrder.person_in_charge.id) || null;
                this.form.teamlead_id = foundOrder.teamlead_id || (foundOrder.teamlead && foundOrder.teamlead.id) || null;
            }
        },
        loadUserData() {
            // Tải danh sách nhân sự HR (department_id = 5)
            ApiService.query("user/filter", { department_id: 5 })
                .then(({ data }) => {
                    const list = Array.isArray(data.data) ? data.data : (Array.isArray(data) ? data : []);
                    this.hrUsers = list;
                })
                .catch(() => {
                    ApiService.query("/list-user", { department_id: 5, limit: 100 })
                        .then(({ data }) => {
                            const list = (data && data.data && (data.data.data || data.data)) || [];
                            this.hrUsers = Array.isArray(list) ? list : [];
                        })
                        .catch(() => {});
                });

            // Tải danh sách Team Leads qua job-recruitment/teacher-groups
            this.$store
                .dispatch(RO_GET_TEACHER_GROUPS, {})
                .then((list) => {
                    this.teamLeads = Array.isArray(list) ? list : [];
                })
                .catch(() => {});
        },
        hrLabel(hr) {
            if (!hr) return "";
            const name = hr.name || hr.full_name || `HR #${hr.id}`;
            const email = hr.email ? ` (${hr.email})` : "";
            return `${name}${email}`;
        },
        tlLabel(tl) {
            if (!tl) return "";
            const name = tl.name || tl.full_name || `TL #${tl.id}`;
            const group = tl.department_name || tl.team_name ? ` - ${tl.department_name || tl.team_name}` : "";
            return `${name}${group}`;
        },
        handleFileChange(file) {
            const raw = file.raw || file;
            if (!raw) return;

            // 1. Kiểm tra định dạng file
            const name = raw.name || "";
            const ext = name.split(".").pop().toLowerCase();
            const allowedExts = ["pdf", "doc", "docx"];
            if (!allowedExts.includes(ext)) {
                this.$message.error(`File "${name}" không đúng định dạng. Chỉ chấp nhận tệp .pdf, .doc, .docx`);
                return;
            }

            // 2. Kiểm tra dung lượng file (tối đa 25MB)
            const maxSize = 25 * 1024 * 1024;
            if (raw.size && raw.size > maxSize) {
                this.$message.error(`File "${name}" vượt quá dung lượng cho phép (tối đa 25MB)`);
                return;
            }

            // 3. Kiểm tra trùng lặp
            const exists = this.uploadRawFiles.some(
                (item) => item.name === raw.name && item.size === raw.size
            );
            if (exists) {
                this.$message.warning(`File "${name}" đã được chọn trong danh sách`);
                return;
            }

            this.uploadRawFiles.push({
                file: raw,
                name: raw.name,
                size: raw.size,
                sizeFormatted: this.formatFileSize(raw.size),
                uid: file.uid || `${raw.name}-${raw.size}-${Date.now()}`,
            });
            this.uploadRawFile = this.uploadRawFiles[0].file;
            this.selectedFileName = this.uploadRawFiles.map((f) => f.name).join(", ");
            this.$message.success(`Đã thêm file "${raw.name}"`);
        },
        removeFile(index) {
            if (index >= 0 && index < this.uploadRawFiles.length) {
                const removed = this.uploadRawFiles.splice(index, 1);
                this.uploadRawFile = this.uploadRawFiles.length > 0 ? this.uploadRawFiles[0].file : null;
                this.selectedFileName = this.uploadRawFiles.map((f) => f.name).join(", ");
                if (removed && removed[0]) {
                    this.$message.info(`Đã xoá file "${removed[0].name}"`);
                }
            }
        },
        clearAllFiles() {
            this.uploadRawFiles = [];
            this.uploadRawFile = null;
            this.selectedFileName = "";
            this.$message.info("Đã xoá tất cả file đính kèm");
        },
        formatFileSize(bytes) {
            if (!bytes || isNaN(bytes)) return "";
            if (bytes < 1024) return `${bytes} B`;
            const kb = bytes / 1024;
            if (kb < 1024) return `${kb.toFixed(1)} KB`;
            const mb = kb / 1024;
            return `${mb.toFixed(1)} MB`;
        },
        close() {
            this.$emit("update:visible", false);
        },
        onClosed() {
            this.form = blankForm();
            this.uploadRawFiles = [];
            this.uploadRawFile = null;
            this.selectedFileName = "";
            if (this.$refs.formRef) this.$refs.formRef.clearValidate();
        },
        submit() {
            this.$refs.formRef.validate((valid, invalidFields) => {
                if (!valid) {
                    if (invalidFields && typeof invalidFields === "object") {
                        const firstKey = Object.keys(invalidFields)[0];
                        const err = invalidFields[firstKey] && invalidFields[firstKey][0];
                        if (err && err.message) {
                            this.$message.warning(err.message);
                        } else {
                            this.$message.warning("Vui lòng điền đầy đủ và chính xác các thông tin bắt buộc");
                        }
                    } else {
                        this.$message.warning("Vui lòng kiểm tra lại các trường thông tin bắt buộc");
                    }
                    return;
                }
                const type = this.isTeacherOrder ? 1 : 0;
                const status = this.isEdit ? (this.form.status !== undefined ? this.form.status : 0) : 0;
                const rawFileList = (this.uploadRawFiles || []).map((item) => item.file);

                const targetOrder = this.selectedOrder || this.findOrder(this.form.job_id);
                const resolvedJobId = (targetOrder && targetOrder.recruitment_job_id !== undefined && targetOrder.recruitment_job_id !== null && targetOrder.recruitment_job_id !== "")
                    ? targetOrder.recruitment_job_id
                    : this.form.job_id;

                const payload = {
                    ...this.form,
                    job_id: resolvedJobId,
                    recruitment_job_id: resolvedJobId,
                    order_id: (targetOrder && targetOrder.id) || this.form.job_id,
                    request_id: (targetOrder && targetOrder.id) || this.form.job_id,
                    source_type: Number(this.form.source_type) || 1,
                    preliminary_info: this.form.preliminary_info || "",
                    type,
                    person_in_charge_id: this.form.person_in_charge_id || null,
                    teamlead_id: this.isTeacherOrder ? (this.form.teamlead_id || null) : null,
                    name: (this.form.name || "").trim(),
                    phone: (this.form.phone || "").trim(),
                    email: (this.form.email || "").trim(),
                    address: this.form.address ? this.form.address.trim() : null,
                    message: this.form.message ? this.form.message.trim() : null,
                    cv_file: rawFileList,
                    cv_files: rawFileList,
                    files: rawFileList,
                    file: rawFileList.length > 0 ? rawFileList[0] : (this.uploadRawFile || null),
                };
                this.$emit("submit", payload);
            });
        },
    },
};
</script>

<style scoped>
/* ==========================================================================
   Header Styling
   ========================================================================== */
.rcv-dialog-header {
    display: flex;
    align-items: center;
    gap: 12px;
}
.rcv-dialog-header__icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%);
    color: #4f46e5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;
}
.rcv-dialog-header__icon.is-edit {
    background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
    color: #d97706;
}
.rcv-dialog-header__info {
    flex: 1;
    min-width: 0;
}
.rcv-dialog-header__title {
    margin: 0;
    font-size: 17px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.3;
}
.rcv-dialog-header__subtitle {
    margin: 2px 0 0 0;
    font-size: 12px;
    color: #64748b;
    line-height: 1.4;
}

/* ==========================================================================
   Form Sectioning & Layout
   ========================================================================== */
.rcv-form {
    padding: 4px 2px;
}
::v-deep .rcv-form .el-form-item__label,
.rcv-form ::v-deep .el-form-item__label {
    padding-bottom: 2px !important;
    line-height: 20px !important;
    font-size: 13px;
    font-weight: 600;
    color: #334155;
    margin-bottom: 0 !important;
}
::v-deep .rcv-form .el-form-item,
.rcv-form ::v-deep .el-form-item {
    margin-bottom: 14px;
}
.rcv-form-section {
    background: #ffffff;
    border: 1px solid #f1f5f9;
    border-radius: 12px;
    padding: 14px 16px;
    margin-bottom: 14px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
    transition: border-color 0.2s;
}
.rcv-form-section:hover {
    border-color: #e2e8f0;
}
.rcv-form-section__head {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13.5px;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f1f5f9;
}
.rcv-form-section__head i {
    color: #4f46e5;
    font-size: 15px;
}
.mb-0 {
    margin-bottom: 0 !important;
}

/* ==========================================================================
   Order Options Custom Styling
   ========================================================================== */
.rcv-order-opt__title {
    font-weight: 600;
    color: #1e293b;
}
.rcv-order-opt__dept {
    float: right;
    color: #94a3b8;
    font-size: 11.5px;
    margin-left: 8px;
}

/* ==========================================================================
   Upload Area & File Card
   ========================================================================== */
.rcv-upload-zone {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.rcv-upload-btn-wrap {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}
.rcv-upload-btn {
    font-weight: 600;
}
.rcv-upload-hint {
    font-size: 12px;
    color: #94a3b8;
}
.rcv-file-card {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #f8fafc;
    border: 1.5px solid #e2e8f0;
    border-radius: 10px;
    padding: 10px 14px;
    transition: all 0.2s;
}
.rcv-file-card:hover {
    border-color: #cbd5e1;
    background: #ffffff;
}
.rcv-file-card__icon {
    width: 34px;
    height: 34px;
    border-radius: 8px;
    background: #eef2ff;
    color: #4f46e5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
}
.rcv-file-card--existing .rcv-file-card__icon {
    background: #ecfdf5;
    color: #059669;
}
.rcv-file-card__info {
    flex: 1;
    min-width: 0;
}
.rcv-file-card__name {
    font-size: 13px;
    font-weight: 600;
    color: #1e293b;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.rcv-file-card__status {
    font-size: 11.5px;
    color: #64748b;
    margin-top: 1px;
}
.rcv-file-card__link {
    font-size: 12px;
    color: #4f46e5;
    font-weight: 600;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-top: 2px;
}
.rcv-file-card__link:hover {
    text-decoration: underline;
}
.rcv-file-card__remove {
    background: #fee2e2;
    border: none;
    color: #dc2626;
    width: 26px;
    height: 26px;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    transition: all 0.2s;
}
.rcv-file-card__remove:hover {
    background: #dc2626;
    color: #ffffff;
}

/* ==========================================================================
   Footer Styling
   ========================================================================== */
.rcv-dialog-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
}
.rcv-btn-cancel {
    border-color: #cbd5e1;
    color: #475569;
}
.rcv-btn-cancel:hover {
    background: #f1f5f9;
    border-color: #94a3b8;
    color: #0f172a;
}
.rcv-btn-submit {
    font-weight: 600;
    padding: 9px 18px;
    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.25);
}
.rcv-source-radios {
    display: flex;
    gap: 12px;
}
.rcv-source-radios /deep/ .el-radio.is-bordered,
.rcv-source-radios ::v-deep .el-radio.is-bordered {
    margin: 0;
    padding: 8px 14px;
    height: auto;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    transition: all 0.2s ease;
}
.rcv-source-radios /deep/ .el-radio.is-bordered.is-checked,
.rcv-source-radios ::v-deep .el-radio.is-bordered.is-checked {
    background-color: #eef2ff;
    border-color: #6366f1;
}

/* Multi-files list styling */
.rcv-files-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12.5px;
    color: #475569;
    font-weight: 600;
    margin-top: 4px;
    padding: 2px 2px;
}
.rcv-files-count {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    color: #4338ca;
}
.rcv-btn-clear-all {
    color: #ef4444 !important;
    padding: 0 !important;
    font-size: 12px;
}
.rcv-btn-clear-all:hover {
    color: #dc2626 !important;
    text-decoration: underline;
}
.rcv-files-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 220px;
    overflow-y: auto;
    padding-right: 2px;
}
.rcv-file-card__size {
    color: #94a3b8;
    font-size: 11.5px;
}
</style>
